import { Tab } from "@mui/material";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";

const GTab = ({
  value,
  changeHandler,
  tabsStyle = {},
  tabsContainerStyle = {},
  tabs = [],
}) => {
  return (
    <Box
      sx={{
        width: "100%",
        padding: "24px 0 36px 0",
        ...tabsContainerStyle,
      }}
    >
      <Tabs
        value={value}
        onChange={changeHandler}
        textColor="inherit"
        TabIndicatorProps={{
          style: {
            backgroundColor: "#219848 !important",
            borderRadius:"10px",
            height: "3px", 
            transition: "all 0.3s ease", 
          },
        }}
        sx={{
          borderBottom: "1px solid #e4e4e7",
          "& .MuiTabs-indicator": {
            backgroundColor: "#219848 !important",
          },
          "& .MuiTab-root": {
            color: "#3F3F46",
            fontWeight: "400",
            fontFamily: "Inter",
            padding: "12px 0",
            minWidth: "0", 
            width: "auto",
            marginRight: "20px",
          },
          "& .Mui-selected": {
            color: "#219848",
            fontWeight: "500",
          },
          ...tabsStyle,
        }}
        aria-label="tabs"
      >
        {tabs.length > 0 &&
          tabs.map((tabLabel, index) => (
            <Tab key={index} disableRipple value={tabLabel.toLowerCase()} label={tabLabel} />
          ))}
      </Tabs>
    </Box>
  );
};

export default GTab;
